import classes from './AddStepButton.module.scss'
import { FiPlus } from 'react-icons/fi'
import {
  Paragraph,
  Tooltip
} from '../..'
import type { ReactNode } from 'react'

export interface BaseProp {
  onClick: () => void
  label: string
  children: ReactNode
  hasPlusIcon?: boolean
}

export interface WithCounterProp {
  counterLabel: string
  counterDescription: string
}

export interface WithoutCounterProp {
  counterLabel?: never
  counterDescription?: never
}

type Props = BaseProp & (WithCounterProp | WithoutCounterProp)

const AddStepButton = ({
  onClick,
  label,
  children,
  counterLabel,
  counterDescription,
  hasPlusIcon = true
}: Props) => {
  const renderCounter = () => {
    if (!counterLabel) return <span className={classes.NoCounter} />

    return (
      <span
        aria-label={`${label}-counter`}
        className={classes.Counter}
      >
        <Tooltip label={counterDescription}>
          <Paragraph>
            {counterLabel}
          </Paragraph>
        </Tooltip>
      </span>
    )
  }

  return (
    <div className={classes.AddStepButton}>
      <button
        aria-label={label}
        onClick={onClick}
        type='button'
      >
        <div className={classes.ContentWrapper}>
          {children}
          {renderCounter()}
          {
            hasPlusIcon && (
              <FiPlus
                aria-hidden
                aria-label='AddStepButtonPlusIcon'
                className={classes.PlusIcon}
                size={18}
              />
            )
          }
        </div>
      </button>
    </div>
  )
}

export default AddStepButton
